module.exports = __webpack_public_path__ + "assets/img/dev2.f3eefdbe.png";